import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { http } from "../../lib/api";

// Alertes terrain des sites où l'agent est en vacation (rondes en retard ou incomplètes, badges / clés non rendus)
export function AgentFieldAlerts() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const load = () => http.get("/agent-app/alerts").then((r) => setItems(r.data)).catch(() => {});
    load();
    const iv = setInterval(load, 120000);
    return () => clearInterval(iv);
  }, []);
  if (!items.length) return null;
  return (
    <section className="rounded-xl border-2 border-rose-300 bg-rose-50 p-3 space-y-2" data-testid="agent-field-alerts">
      <div className="flex items-center gap-2 text-rose-800 font-extrabold text-sm"><AlertTriangle className="h-4 w-4" />Alertes du site ({items.length})</div>
      {items.map((a) => (
        <div key={a.key} className="bg-white rounded-lg px-3 py-2 border border-rose-200" data-testid={`agent-alert-${a.type}`}>
          <div className="text-sm font-bold text-rose-900">{a.title}</div>
          <div className="text-xs text-slate-600">{a.detail}</div>
        </div>
      ))}
    </section>
  );
}
